import Boundary from './Boundary.js';

import { getOSM } from '../OverworldAnimation.js';

export default class LocationIndicatorZone extends Boundary {
    constructor({ locationId, position }) {
        super({ position });
        this.locationId = locationId;
        this.position = position;
        this.width = 16;
        this.height = 16;
        this.visible = true;
    }

    serialize() {
        return {
            locationId: this.locationId,
            position: this.position,
            width: this.width,
            height: this.height,
        };
    }

    static deserialize(data) {
        return new LocationIndicatorZone({
            locationId: data.locationId,
            position: data.position,
            width: data.width,
            height: data.height,
        });
    }

    entered() {
        const playerPosition = getOSM().player.position;
        return playerPosition.x === this.position.x && playerPosition.y === this.position.y;
    }

    draw() {
        // c.fillStyle = 'rgba(255, 255, 255, 1)';
        // c.fillRect(this.effectivePosition().x, this.effectivePosition().y, this.width, this.height);
    }
}
